import { Routes, RouterModule } from '@angular/router';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'privacypolicy',
    loadChildren: () => import('./privacypolicy/privacypolicy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: 'termscondition',
    loadChildren: () => import('./termscondition/termscondition.module').then(m => m.TermsconditionModule)
  },
  // { 
  //   path: 'pages',
  //   loadChildren: () => import('./pages/pages.module').then(m=>m.PagesModule)
  // },
  {
    path: '**',
    redirectTo: 'home'
  }
];

